enum EventKey {
  RequestForbidden = 'REQUEST_FORBIDDEN',
  HandleCustomError = 'HANDLE_CUSTOM_ERROR',
  HideErrorToast = 'HIDE_ERROR_TOAST',
  ShareUserProfilePermissions = 'SHARE_USER_PROFILE_PERMISSIONS',
  RemountComponentTree = 'REMOUNT_COMPONENT_TREE',
}

export default EventKey;
